module.exports = __webpack_public_path__ + "img/footer-logo.d18226ff.png";